export default "__VITE_ASSET__BLNpQ4jh__"